import { createSlice } from "@reduxjs/toolkit";

export interface InitialState {
  cartDrawerIsOpen: boolean;
  sidebarIsOpen: boolean;
}

const initialState: InitialState = {
  cartDrawerIsOpen: false,
  sidebarIsOpen: false,
};

const drawersSlice = createSlice({
  name: "drawersSlice",
  initialState,
  reducers: {
    setCartDrawerState: (state, { payload }) => {
      state.cartDrawerIsOpen = payload;
    },

    setSidebarIsOpen: (state, { payload }) => {
      state.sidebarIsOpen = payload;
    },
  },
});

export const { setCartDrawerState, setSidebarIsOpen } = drawersSlice.actions;

export default drawersSlice.reducer;
